import { render, staticRenderFns } from "./BaseButtonWhiteSmall.vue?vue&type=template&id=b858f5f6&"
import script from "./BaseButtonWhiteSmall.vue?vue&type=script&lang=js&"
export * from "./BaseButtonWhiteSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports